import React from 'react';
function BMIChildrenTable({ classification }) {
    return (
        <table >
            <thead>
                <tr>
                    <th >Centile Range</th>
                    <th >Weight Status Category</th>
                </tr>
            </thead>
            <tbody>
                <tr className={classification === 'Underweight' ? 'highlightedWarning' : ''}>
                    <td>Less than 5%</td>
                    <td>Underweight</td>
                </tr>
                <tr className={classification === 'Healthy weight' ? 'highlightedOk' : ''}>
                    <td>5% to 85%</td>
                    <td>Healthy weight</td>
                </tr>
                <tr className={classification === 'At risk of overweight' ? 'highlightedWarning' : ''}>
                    <td>85% to 95%</td>
                    <td>At risk of overweight</td>
                </tr>
                <tr className={classification === 'Overweight' ? 'highlightedDanger' : ''}>
                    <td>Greater than or equal to 95%</td>
                    <td>Overweight</td>
                </tr>
                <tr>
                    <td colSpan="2">
                        <b>Source:</b>{' '} <br />
                        <a href="https://www.cdc.gov/bmi/faq/">
                            Centers for Disease Control and Prevention - National Center for Health Statistics
                        </a>
                    </td>
                </tr>
                <tr>
                    <td colSpan="2">
                        <b>Last Reviewed Date:</b> 28/02/2026
                    </td>
                </tr>
            </tbody>
        </table>
    );
}
export default BMIChildrenTable;
